import { computed, onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Skill } from '../../../core/models/skill'
import type { FeedbackTopicType } from '../../../core/models/feedback-topic'

export const useProfile = async () => {
  const { data, status, load } = useGet<ProfileViewModel>(`profile`)

  onMounted(() => {
    load()
  })

  const feedbackTopics = computed(() => {
    return data.value?.feedbackTopics ?? []
  })

  const superpower = computed(() => {
    return data.value?.superpower ?? null
  })

  return { feedbackTopics, superpower, status }
}

export interface ProfileViewModel {
  readonly superpower: Skill | null
  readonly feedbackTopics: ReadonlyArray<{
    id: string
    title: string
    icon: string
    type: FeedbackTopicType
    disabled: boolean
  }>
}
